import { createStore, sample, split } from 'effector'

import { $portalProfile } from '@/entities/profile/portal'
import { persist } from '@/shared/lib/persist/local'

const $lastLoginPublicId = createStore<string | null>(null)

persist({
    store: $lastLoginPublicId,
    sync: true,
    key: 'portal-last-login-public-id',
})

sample({
    clock: $portalProfile,
    fn: (profile) => profile?.publicId ?? null,
    target: $lastLoginPublicId,
})

export function trackRelogin() {
    const loginChanged = sample({
        source: {
            profile: $portalProfile,
            lastLoginPublicId: $lastLoginPublicId,
        },
    })

    const cases = split(loginChanged, {
        externalLogout: (params) => params.profile !== null && params.lastLoginPublicId === null,
        externalLogin: (params) =>
            params.profile !== null &&
            params.lastLoginPublicId !== null &&
            params.lastLoginPublicId !== params.profile.publicId,
    })

    return {
        reloginDetected: cases.externalLogin,
    }
}
